import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=49991738&scoped=true&"
import script from "./Resident.vue?vue&type=script&lang=ts&"
export * from "./Resident.vue?vue&type=script&lang=ts&"
import style0 from "./Resident.vue?vue&type=style&index=0&id=49991738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49991738",
  null
  
)

export default component.exports